import { addCalendarDays } from "@common/helpers/date";
import { ScheduleTermUnit } from "@common/types/domains/accounting/schedule";

function shiftMonthStart(monthStart: string, monthCount: number): string {
    const [year, month] = monthStart.split("-").map(Number);
    const monthIndex = year * 12 + (month - 1) + monthCount;
    const shiftedYear = Math.floor(monthIndex / 12);
    const shiftedMonth = (monthIndex % 12) + 1;
    return `${String(shiftedYear).padStart(4, "0")}-${String(shiftedMonth).padStart(2, "0")}-01`;
}

/**
 * The default term start of an accrued schedule billed on `sourceDate`: the
 * term runs back from the billing month, so its last period is the month
 * before the one the invoice or payment lands in.
 */
export function getAccruedDefaultTermStart(options: {
    sourceDate: string;
    termLength: number;
    termUnit: ScheduleTermUnit;
}): string {
    const billingMonthStart = `${options.sourceDate.slice(0, 7)}-01`;
    switch (options.termUnit) {
        case ScheduleTermUnit.days:
            return addCalendarDays(billingMonthStart, -options.termLength);
        case ScheduleTermUnit.weeks:
            return addCalendarDays(billingMonthStart, -options.termLength * 7);
        case ScheduleTermUnit.months:
            return shiftMonthStart(billingMonthStart, -options.termLength);
        case ScheduleTermUnit.years:
            return shiftMonthStart(billingMonthStart, -options.termLength * 12);
    }
}
